import { Box, Divider, Link, Typography } from '@mui/material';

const OxFooter = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Divider sx={{ marginBlockEnd: 3 }} />
      <Typography variant='body2' color='text.primary'>
        OX Security {new Date().getFullYear()}
        <Link
          href='https://www.ox.security/terms-of-service/'
          target='_blank'
          sx={{
            color: 'inherit',
            marginInline: 1,
            textDecoration: 'underline',
          }}>
          Terms of Service
        </Link>
        <Link
          href='https://www.ox.security/privacy-policy/'
          target='_blank'
          sx={{
            color: 'inherit',
            marginInline: 1,
            textDecoration: 'underline',
          }}>
          Privacy Policy
        </Link>
      </Typography>
    </Box>
  );
};

export default OxFooter;
